import validator from "is_js";
import { Messages } from "./constants";

const checkNumEmpty = (val, key) => {
  if (validator.empty(val)) {
    return `${key}`;
  } else {
    return "";
  }
};

const checkEmpty = (val, key) => {
  if (validator.empty(val.toString().trim())) {
    return `${key}`;
  } else {
    return "";
  }
};

const isPriceValid = (val) => {
  if (val < 0) return Messages.validation.negativePrice;
  if (val < 1) return Messages.validation.invalidPrice;
  let regexPrice = /^([+]?\d+\.?\d{0,2})$/;
  if (!regexPrice.test(val)) {
    return Messages.validation.invalidPrice;
  }
};

const isQuantityValid = (val) => {
  if (val < 0) return Messages.validation.negativeQuantity;
  let quantityRegex = /^([+]?\d+)$/;
  if (!quantityRegex.test(val)) {
    return Messages.validation.invalidQuantity;
  }
};

const isWeightValid = (val) => {
  if (Number(val) < 0) return Messages.validation.negativeWeight;
  let rgx = /^[0-9]\d*$/;
  if (!rgx.test(val)) {
    return Messages.validation.invalidWeight;
  }
  return "";
};

const isWeightValidWithDecimal = (val) => {
  if (Number(val) === 0) return Messages.validation.zeroWeight;
  if (Number(val) < 0) return Messages.validation.negativeWeight;
  let rgx = /^([+]?\d+\.?\d{0,2})$/;
  if (!rgx.test(val)) {
    return Messages.validation.invalidWeight;
  }
  return "";
};

const isOzValid = (val) => {
  if (Number(val) < 0) return Messages.validation.negativeWeight;
  if (Number(val) > 15) return Messages.validation.ouncesLimit;
  let rgx = /^[0-9]\d*$/;
  if (!rgx.test(val)) {
    return Messages.validation.invalidWeight;
  }
  return "";
};

export default function (data) {
  const {
    productName,
    description,
    productPrice,
    quantity,
    weight,
    categoryName,
    ounces,
    weightUnit,
  } = data;

  if (productName !== undefined) {
    let emptyValidationText = checkEmpty(
      productName,
      Messages.validation.isEmpty
    );
    if (emptyValidationText !== "") {
      return emptyValidationText;
    }
  }
  if (description !== undefined) {
    let emptyValidationText = checkEmpty(
      description,
      Messages.validation.isEmpty
    );
    if (emptyValidationText !== "") {
      return emptyValidationText;
    }
  }
  if (productPrice !== undefined) {
    let emptyValidationText = checkEmpty(
      productPrice,
      Messages.validation.isEmpty
    );
    if (emptyValidationText !== "") {
      return emptyValidationText;
    } else {
      let minLengthValidation = isPriceValid(productPrice);
      if (minLengthValidation !== "") {
        return minLengthValidation;
      }
    }
  }
  if (quantity !== undefined) {
    let emptyValidationText = checkEmpty(quantity, Messages.validation.isEmpty);
    if (emptyValidationText !== "") {
      return emptyValidationText;
    } else {
      let minLengthValidation = isQuantityValid(quantity);
      if (minLengthValidation !== "") {
        return minLengthValidation;
      }
    }
  }
  console.log("weight to validate ", weight);

  if (weight === null) {
    return Messages.validation.zeroWeight;
  }
  if (Number(weight) === 0 && Number(ounces) === 0) {
    return Messages.validation.zeroWeight;
  }
  if (weight !== undefined && ounces !== undefined) {
    let emptyValidationText = checkEmpty(ounces, Messages.validation.isEmpty);
    if (emptyValidationText !== "") return emptyValidationText;
    emptyValidationText = checkEmpty(weight, Messages.validation.isEmpty);

    if (emptyValidationText !== "") return emptyValidationText;

    let minLengthValidation = isOzValid(ounces);
    if (minLengthValidation !== "") return minLengthValidation;
    minLengthValidation = isWeightValid(weight);
    if (minLengthValidation !== "") return minLengthValidation;
  }
  if (ounces !== undefined) {
    let emptyValidationText = checkEmpty(ounces, Messages.validation.isEmpty);

    if (emptyValidationText !== "") return emptyValidationText;
    let minLengthValidation = isOzValid(ounces);
    if (minLengthValidation !== "") return minLengthValidation;
  }
  if (weight !== undefined && weightUnit !== "lb") {
    let emptyValidationText = checkNumEmpty(
      weight,
      Messages.validation.isEmpty
    );
    if (emptyValidationText !== "") {
      return emptyValidationText;
    }
    let minLengthValidation = isWeightValidWithDecimal(weight);
    if (minLengthValidation !== "") {
      return minLengthValidation;
    }
  }
  if (categoryName !== undefined) {
    let emptyValidationText = checkEmpty(
      categoryName,
      Messages.validation.isEmptyCategory
    );
    if (emptyValidationText !== "") {
      return emptyValidationText;
    }
  }
}
